import { useI18n } from '#/i18n/hooks/useI18n';

import { LayoutHeaderPanelLogoutLink } from './LayoutHeaderPanel.styled';
import type { LayoutHeaderPanelIcon } from './LayoutHeaderPanelIcon';
import { LayoutHeaderPanelRowContent } from './LayoutHeaderPanelRowContent';

type Props = {
  qaId: string;
};

// Empty slot keeps the label aligned with the icon rows above
const logoutIcon: LayoutHeaderPanelIcon = { kind: 'none' };

export function LayoutHeaderPanelLogoutRow({ qaId }: Props) {
  const { i18n } = useI18n();

  return (
    <li>
      <LayoutHeaderPanelLogoutLink
        qaId={qaId}
        type="link"
        href="/logout"
        anchorType="native"
      >
        <LayoutHeaderPanelRowContent
          icon={logoutIcon}
          title={i18n('Log Out')}
        />
      </LayoutHeaderPanelLogoutLink>
    </li>
  );
}
